import { InjectionToken } from '@angular/core';

export const PLATFORM_MOCK_API_DEFAULT_DELAY = new InjectionToken<number>('PLATFORM_MOCK_API_DEFAULT_DELAY');
